export default __webpack_public_path__ + "static/media/1.742cfa71.webp";